<template>
  <SlidingPagination
    class="ts-pagination"
    page-component="the-source-pagination-2-page"
    v-bind="$attrs"
    v-on="$listeners"
  ></SlidingPagination>
</template>

<style lang="scss" scoped>
.ts-pagination::v-deep {
  .c-sliding-pagination__list {
    .c-sliding-pagination__list-element {
      background: none;
      padding: 0;

      .c-sliding-pagination__page {
        font-family: Roboto;
        font-size: 10px;
        color: #9aa5b7;
        padding: 8px;
      }
    }
  }
}
</style>

<script>
import SlidingPagination from 'vue-sliding-pagination';
import 'vue-sliding-pagination/dist/style/vue-sliding-pagination.css';

export default {
  name: 'TsPagination2',
  components: {
    SlidingPagination
  }
};
</script>
